import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ChartHelperService } from '@app/backend/chart-helper.service';
import { GraphReportComponent } from '@app/gui/report/graph-report/graph-report.component';
import { highcharts } from '@lib/highcharts';
import * as Highcharts from 'highcharts';

@Component({
  selector: 'app-dashboard-chart-group',
  templateUrl: './dashboard-chart-group.component.html',
  styleUrls: ['./dashboard-chart-group.component.css']
})
export class DashboardChartGroupComponent {

  @Input() chartOptions: any[] = [];
  @Input() Highcharts: typeof Highcharts = highcharts;

  @Output() chartInstance = new EventEmitter<{ chart: Highcharts.Chart, index: number }>();

  chartRefs: Highcharts.Chart[] = [];
  visibleDownloadMenuIndex: number | null = null;
  @Input() showExportButton: boolean = false;

  constructor(
    private chartHelper: ChartHelperService,
  ) { }

  onChartInstance(chart: Highcharts.Chart, index: number): void {
    this.chartRefs[index] = chart;
    this.chartInstance.emit({ chart, index });
  }

  toggleDownloadMenu(index: number): void {
    this.visibleDownloadMenuIndex = this.chartHelper.toggleDownloadMenu(index, this.visibleDownloadMenuIndex);
  }

  downloadCSV(index: number): void {
    this.chartHelper.downloadCSV(this.chartRefs[index]);
    this.visibleDownloadMenuIndex = null;
  }

  downloadXLS(index: number): void {
    this.chartHelper.downloadXLS(this.chartRefs[index]);
    this.visibleDownloadMenuIndex = null;
  }

  onFullScreenClick(index: number): void {
    this.chartHelper.toggleFullScreen(this.chartRefs[index]);
  }

  onTableViewClick(index: number): void {
    const chart = this.chartRefs[index];
    if (chart) {
      this.chartHelper.viewChartData(chart, index);
    }
  }
}